import { useQuery } from '@tanstack/react-query';
import { estadiaClienteService } from '../../services/estadiaClienteService';
import type { StatusEstadiaCliente } from '../../models/estadiaCliente.types';

export const SI_ESTADIAS_CLIENTE_QUERY_KEYS = {
  all: ['si', 'estadias-cliente'] as const,
  detalhe: (id: string) => [...SI_ESTADIAS_CLIENTE_QUERY_KEYS.all, 'detalhe', id] as const,
  lista: (clienteId?: string, status?: StatusEstadiaCliente) =>
    [...SI_ESTADIAS_CLIENTE_QUERY_KEYS.all, 'lista', clienteId ?? 'todos', status ?? 'todos'] as const,
  prontasNoCliente: (clienteId?: string) =>
    [...SI_ESTADIAS_CLIENTE_QUERY_KEYS.all, 'prontas', clienteId ?? ''] as const,
  porEquipamento: (equipamentoId?: string) =>
    [...SI_ESTADIAS_CLIENTE_QUERY_KEYS.all, 'por-equipamento', equipamentoId ?? ''] as const,
};

export function useEstadiasClienteQuery(filtro?: { clienteId?: string; status?: StatusEstadiaCliente }) {
  return useQuery({
    queryKey: SI_ESTADIAS_CLIENTE_QUERY_KEYS.lista(filtro?.clienteId, filtro?.status),
    queryFn: () => estadiaClienteService.listar(filtro),
  });
}

export function useEstadiaClienteQuery(id: string | undefined) {
  return useQuery({
    queryKey: SI_ESTADIAS_CLIENTE_QUERY_KEYS.detalhe(id ?? ''),
    queryFn: () => estadiaClienteService.getById(id as string),
    enabled: Boolean(id),
  });
}

/** Fase 2 — sugestão de equipamento já pronto no Cliente da Movimentação de envio (ver
 * SugestaoEstadiaClienteSection). */
export function useEstadiasProntasNoClienteQuery(clienteId: string | undefined) {
  return useQuery({
    queryKey: SI_ESTADIAS_CLIENTE_QUERY_KEYS.prontasNoCliente(clienteId),
    queryFn: () => estadiaClienteService.listarProntasNoCliente(clienteId as string),
    enabled: Boolean(clienteId),
  });
}

/** Histórico de passagens por Cliente de um Equipamento — resumo só-leitura na
 * Movimentação, ver HistoricoEstadiasEquipamentoSection. */
export function useEstadiasDoEquipamentoQuery(equipamentoId: string | undefined) {
  return useQuery({
    queryKey: SI_ESTADIAS_CLIENTE_QUERY_KEYS.porEquipamento(equipamentoId),
    queryFn: () => estadiaClienteService.listarPorEquipamento(equipamentoId as string),
    enabled: Boolean(equipamentoId),
  });
}
